export const VARIATION_PLP = 'plp'
export const VARIATION_PDP = 'pdp'
export const VARIATION_CROSS_SELL = 'cross-sell'
export const VARIATION_SMALL = 'small'
